import React, { useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { Spinner } from 'reactstrap';
import { getSanitizedS3BucketUrl } from '../../helpers';

const DragAndDropField: React.FC<any> = (props) => {
  const {
    label,
    name,
    fileType,
    handleUploadFile,
    validFileTypes,
    currentFileName = '',
    previewStatus = false,
  } = props;
  const [isUploading, setIsUploading] = useState(false);
  const [file, setFile] = useState<{
    name: string;
  }>({
    name: '',
  });
  const [imagePreview, setImagePreview] = useState<string | null>(null);

  const s3BucketUrl = getSanitizedS3BucketUrl();
  const formatImageUrl = (url: string) =>
    url && url[0] === '/' ? url.substring(1, url.length) : url;

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    currentFileName &&
      setImagePreview(`${s3BucketUrl}/${formatImageUrl(currentFileName)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFileName]);

  const handleChangeFileUpload = async (uploadedFile: File) => {
    setFile(uploadedFile);
    setIsUploading(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result as string);
    };
    reader.readAsDataURL(uploadedFile);

    try {
      await handleUploadFile(uploadedFile, fileType);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Upload failed:', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <div className="ar-preview-img">
        {previewStatus && imagePreview && (
          <div className="ar-preview-img-wrapper">
            <img src={imagePreview} alt="Preview" className="img-fluid" />
            {isUploading && (
              <div className="upload-overlay">
                <Spinner color="primary" />
                <span>Uploading...</span>
              </div>
            )}
          </div>
        )}
        <FileUploader
          handleChange={handleChangeFileUpload}
          name="file"
          types={validFileTypes}
          disabled={isUploading}
        />
      </div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="form-group__hint">
        {file.name
          ? `${file.name} ${isUploading ? '(Uploading...)' : ''}`
          : currentFileName || 'No files uploaded yet'}
      </label>
    </div>
  );
};

export default DragAndDropField;
